export enum ThemeTypeEnum {
  light = "light-theme-type",
	dark = "dark-theme-type",
}

export enum ThemeColorEnum {
  blue = "blue-theme",
  red = "red-theme",
	orange = "orange-theme",
  purple = "purple-theme"
}